const getTouchDevice = () => {
    if (window.PointerEvent && ('maxTouchPoints' in navigator) && navigator.maxTouchPoints > 0) return navigator.maxTouchPoints !== 256; // баг windows10
    if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) return true;
    return 'ontouchstart' in window;

};

export default getTouchDevice;
